import { Helper } from "../core/util/helper";
import { HTTPService, JsonResultClass } from "../core/util/httpManager";
import { General } from "../../siteManagement/general";
import { SheetEventType } from "../../siteManagement/sheet";
import EditRole, { EditRoleProps } from "./editRole";
import { ReportDefinition, TargetEntityType } from "./reportMetaData";
import { RoleViewModel } from "./signatureGrid";
import { DropDownListField } from "../core/components/dropDownList";
import { Metadata } from "../core/components/commonApp";
import { KeyValuePair } from "../commonInterfaces";

export class ReportMetaDataHelper {

    public static checkForLanguageConsistency = async (reportDefinition: ReportDefinition) => {
        const getUnusedLanguages = (lst: string[]): string[] => {
            //weil javascript -.-
            return languages.filter(l => lst.findIndex(n => n === l) === -1)
        }
        let names = ReportMetaDataHelper.getNoneEmptyKeys(reportDefinition.Name);
        let files = ReportMetaDataHelper.getNoneEmptyKeys(reportDefinition.ReportFiles);
        var languages: string[] = Helper.mergeLists(names, files);
        const signatures = Helper.getValueOrDefault(reportDefinition.Signatures, []);
        let reasons: any[] = signatures.map((signatur) => {
            let r = ReportMetaDataHelper.getNoneEmptyKeys((signatur.Reasons || {}));
            languages = Helper.mergeLists(languages, r);
            return {
                uniqueName: signatur.UniqueName,
                reasons: r
            }
        });
        //nicht mehr verwendete Sprache aussotieren
        const langs = await ReportMetaDataHelper.getLanguages();
        languages = languages.filter(f1 => langs.findIndex(f2 => f2.Code === f1) > -1);

        let lst1 = getUnusedLanguages(names);
        let lst2 = getUnusedLanguages(files);
        let lst3: any[] = [];
        if (reasons.filter(f => (f["reasons"] as []).length > 0).length > 0) {
            lst3 = reasons.map(item => {
                return {
                    uniqueName: item.uniqueName,
                    reasons: getUnusedLanguages(item.reasons)
                }
            });
        }
        if (lst1.length === 0 && lst2.length === 0 && (lst3.filter(f => f.reasons.length > 0).length === 0)) {
            return null;
        } else {
            return {
                names: lst1,
                files: lst2,
                signatures: lst3
            }
        }
    }

    private static getNoneEmptyKeys = (obj: {}): string[] => {
        let result: string[] = [];
        Object.keys((obj)).forEach((key: string) => {
            if (!Helper.isNullOrEmpty(obj[key])) {
                result.push(key);
            }
        });
        return result.sort((a: string, b: string) => {
            if (a < b) { return -1; }
            if (a > b) { return 1; }
            return 0;
        });
    }

    public static dictionaryContainsAtLeastEntry = (obj: {}): boolean => {
        let keys = Object.keys(obj);
        for (let i = 0; i < keys.length; i++) {
            if (!Helper.isNullOrEmpty(obj[keys[i]])) {
                return true;
            }
        }
        return false;
    }

    public static getLanguages = (): Promise<Language[]> => {
        return new Promise<Language[]>((resolve) => {
            HTTPService.get<JsonResultClass<Language[]>>("EditIndividualFields/GetLanguages").then((result) => {
                if (result.Code == 0) {
                    resolve(result.Data);
                } else {
                    resolve([]);
                }
            });
        });
    }

    public static getDisplayText = (multilang: {}): string => {
        if (!Helper.hasValue(multilang))
            multilang = {};
        let keys = Object.keys(multilang);
        let browserLanguages = navigator.languages;
        let index: number;
        if (keys.length === 0)
            return "";
        for (let i = 0; i < browserLanguages.length; i++) {
            index = keys.findIndex(f => f === browserLanguages[i]);
            if (index > -1) {
                return multilang[keys[index]];
            }
        }
        return multilang[keys[0]];
    }

    public static createNewRole = (): Promise<RoleViewModel> => {
        return new Promise<KeyValuePair<number, string>>((resolve) => {
            Helper.getTranslations(["WebSMS.ReportMetadata.WellKnownSigneeRole", "Server.Allgemein", "Standard.Bezeichnung", "Standard.BitteWählen", "Field.Adresse.language", "Parts.TranslationLink.LabelTranslation", "WebSMS.ReportMetadata.NameIsMissing"]).then((result) => {
                const translations = result.Data;
                const nameField = {
                    model: "entity.Name",
                    name: "name",
                    type: "dynamic",
                    visible: true,
                    readOnly: false,
                    labelAndControlCombined: true,
                    moduleName: "app/reportMetaData/editTranslations"
                }
                const dropDown: DropDownListField = {
                    visible: true,
                    required: false,
                    name: translations["WebSMS.ReportMetadata.WellKnownSigneeRole"],
                    model: "entity.WellKnownSigneeRole",
                    readOnly: false,
                    type: "kendo-drop-down-list",
                    optionLabel: translations["Standard.BitteWählen"],
                    dataSourceUrl: "ReportMetaData/GetWellKnownRoles",
                    dataTextField: "Value",
                    dataValueField: "Key",
                }
                let metaData: Metadata = {
                    menuDataSource: [{
                        type: "save"
                    }],
                    tabs: [
                        {
                            title: "",
                            iconName: "",
                            regions: [
                                {
                                    title: translations["Server.Allgemein"],
                                    visible: true,
                                    fields: [
                                        dropDown
                                    ]
                                },
                                {
                                    title: translations["Standard.Bezeichnung"],
                                    visible: true,
                                    fields: [
                                        nameField,
                                    ]
                                }
                            ]
                        }
                    ],
                    additional: {
                        objects: []
                    },
                };
                let props: EditRoleProps = {
                    context: {
                        translations: {
                            "Field.Adresse.language": translations["Field.Adresse.language"],
                            "Parts.TranslationLink.LabelTranslation": translations["Parts.TranslationLink.LabelTranslation"],
                            "WebSMS.ReportMetadata.NameIsMissing": translations["WebSMS.ReportMetadata.NameIsMissing"]
                        },
                    },
                    dataSources: null,
                    entity: {
                        IsNew: true,
                        RecordRight: {
                            CanRead: true,
                            CanWrite: true
                        },
                        Name: {},
                        WellKnownSigneeRole: null,
                        IsWatchable: false,
                        IsWatched: false
                    },
                    isWindow: false,
                    metadata: metaData,
                    title: ""
                }
                const sheet = General.Sheet.Manager.createSheet();
                sheet.bind(SheetEventType.Custom, (data: { cmd: string, data: any }) => {
                    switch (data.cmd) {
                        case "afterSuccessfullySave":
                            resolve(data.data);
                            break;
                    }
                });
                sheet.bind(SheetEventType.Close, () => {
                    resolve(null);
                })
                sheet.show(() => {
                    sheet.mountContent(EditRole, props);
                });
            });           
        });
    }

    public static getFileName = (path: string) => {
        if (Helper.isNullOrEmpty(path))
            return "";
        let arr = path.split("\\");
        return arr[arr.length - 1];
    }

    public static getTargetEntityTypeName = (value: number) => {
        const e = TargetEntityType as any;  
        for (var k in e) if (e[k] == value) return k;
        return null;
    }
}

export interface Language {
    Code: string;
    Displaynameen: string;
    Displaynamenative: string;
    Fallbackid: number;
    Id: number;
}